import DefaultRule from './default_rule';
import PrevalenceRule from './prevalence_rule';
import VendorNameRule from './vendor_name_rule';
import MetricNameRule from './metric_name_rule';

import DisclosedMetricRule from './non_disclosed_metric_rules/disclosed_metric_rule';
import NonDisclosedMetricRule from './non_disclosed_metric_rules/non_disclosed_metric_rule';
import DisclosedTriggeringNonDisclosedMetricRule from './non_disclosed_metric_rules/disclosed_triggering_non_disclosed_rule';
import CollapsedChildrenRule from './collapsed_children_rule';
import PriorToConsentRule from './prior_to_consent_rule';
import VendorHighlightRule from './highlight_rule';

export default class RuleService {
    constructor() {
        this.rules = [
            new PriorToConsentRule(),
            new MetricNameRule(),

            new DisclosedTriggeringNonDisclosedMetricRule(),
            new NonDisclosedMetricRule(),
            new DisclosedMetricRule(),

            new VendorHighlightRule(),
            new VendorNameRule(),
            new CollapsedChildrenRule(),
            new PrevalenceRule(),
            new DefaultRule(),
        ];
    }
    getColor(filters, node) {
        for (const rule of this.rules) {
            if (rule.isSupport(filters, node)) {
                return rule.getColor(filters, node);
            }
        }
    }
    getTextColor(filters, node) {
        for (const rule of this.rules) {
            if (rule.isSupport(filters, node)) {
                return rule.getTextColor(filters, node);
            }
        }
    }
    getNodeBackgroundColor(filters, node) {
        for (const rule of this.rules) {
            if (rule.isSupport(filters, node)) {
                return rule.getNodeBackgroundColor(filters, node);
            }
        }
    }
    getOpacity(filters, node) {
        for (const rule of this.rules) {
            if (rule.isSupport(filters, node)) {
                return rule.getOpacity(filters, node);
            }
        }
    }
}
